import { useAccessibility } from '../../../context/AccessibilityContext/AccessibilityContext';
import Block from '../../../components/Block/Block';
import style from './bannerblock.module.scss';
import banner from '../../../assets/banner.jpg';

const BannerBlock = () => {
    const { settings } = useAccessibility();

    // Accessibility-aware styles
    const bannerStyles = {
        backgroundColor: settings.contrast === 'default' ? '#0a0a2e' : 'var(--bg-primary)',
        color: settings.contrast === 'default' ? '#fff' : 'var(--text-primary)',
    };

    return (
        <Block
            width="100%"
            height='200px'
            background={bannerStyles.backgroundColor}
            role="banner"
            aria-label="Main promotional banner"
        >
            <div className={style.content}>
                {/* Волны градиента для фона */}
                <div className={style.wavesContainer}>
                    <div className={style.backgroundOverlay} aria-hidden="true" />
                    <div className={style.sportWaves} aria-hidden="true" />
                </div>

                <div 
                    className={style.wrapperHeader}
                    role="heading"
                    aria-level="1"
                >
                    <h1
                        className={style.header}
                        style={{ color: bannerStyles.color }}
                        tabIndex="0"
                    >
                        ПОДРАЗДЕЛЕНИЯ
                    </h1>
                </div>
            </div>
        </Block>
    );
};

export default BannerBlock;